import { render, staticRenderFns } from "./screenShot.vue?vue&type=template&id=58b5fc28&"
import script from "./screenShot.vue?vue&type=script&lang=js&"
export * from "./screenShot.vue?vue&type=script&lang=js&"
import style0 from "./screenShot.vue?vue&type=style&index=0&lang=scss&scpoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports